import React, { lazy, Suspense } from 'react';

const LazyDataTransmission = lazy(() => import('./DataTransmission'));

const DataTransmission = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyDataTransmission {...props} />
  </Suspense>


);

export default DataTransmission;
